module.exports = __webpack_public_path__ + "img/4-1.54a9aa9e.svg";